module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('h3', {
    staticClass: "primary--text"
  }, [_c('v-icon', {
    attrs: {
      "info": ""
    }
  }, [_vm._v("person_outline")]), _vm._v(" " + _vm._s(_vm.$t('documento.title')))], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('crud-table', {
    attrs: {
      "headers": _vm.headers,
      "url": _vm.url,
      "filters": _vm.filters,
      "graphql": _vm.graphql,
      "data-graphql": _vm.dataGraphql,
      "widthModal": 800
    },
    scopedSlots: _vm._u([{
      key: "form",
      fn: function(props) {
        return [_c('v-card-title', {
          staticClass: "headline"
        }, [_c('v-icon', [_vm._v(_vm._s(_vm.form.id ? 'folder' : 'create_new_folder'))]), _vm._v(" " + _vm._s(_vm.form.id ? _vm.$t('documento.crud.editDocumento') : _vm.$t('documento.crud.addDocumento')) + "\n            "), _c('v-btn', {
          attrs: {
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.$store.commit('closeModal')
            }
          }
        }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-form', {
          ref: "form",
          attrs: {
            "lazy-validation": ""
          },
          on: {
            "submit": function($event) {
              $event.preventDefault();
              return _vm.save($event)
            }
          },
          model: {
            value: (_vm.valid),
            callback: function($$v) {
              _vm.valid = $$v
            },
            expression: "valid"
          }
        }, [_c('v-card-text', [_c('v-container', {
          attrs: {
            "grid-list-md": ""
          }
        }, [_c('v-layout', {
          attrs: {
            "row": "",
            "wrap": ""
          }
        }, [_c('v-flex', {
          attrs: {
            "xs6": ""
          }
        }, [_c('v-select', {
          attrs: {
            "items": _vm.entidades,
            "label": "Entidad",
            "item-text": "text",
            "item-value": "value",
            "autocomplete": "",
            "noDataText": "No hay resultados",
            "rules": _vm.$validate(['required']),
            "required": ""
          },
          model: {
            value: (_vm.form.id_entidad),
            callback: function($$v) {
              _vm.$set(_vm.form, "id_entidad", $$v)
            },
            expression: "form.id_entidad"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs6": ""
          }
        }, [_c('v-select', {
          attrs: {
            "items": _vm.derivar_opciones,
            "label": "Derivar a:",
            "item-text": "text",
            "item-value": "value",
            "autocomplete": "",
            "noDataText": "No hay resultados",
            "rules": _vm.$validate(['required']),
            "required": ""
          },
          model: {
            value: (_vm.form.derivar),
            callback: function($$v) {
              _vm.$set(_vm.form, "derivar", $$v)
            },
            expression: "form.derivar"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs6": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Nombre",
            "maxlength": "100"
          },
          model: {
            value: (_vm.form.nombre),
            callback: function($$v) {
              _vm.$set(_vm.form, "nombre", $$v)
            },
            expression: "form.nombre"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs6": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Código portal",
            "maxlength": "50"
          },
          model: {
            value: (_vm.form.codigo_portal),
            callback: function($$v) {
              _vm.$set(_vm.form, "codigo_portal", $$v)
            },
            expression: "form.codigo_portal"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs12": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Descripcion",
            "maxlength": "500",
            "multi-line": "",
            "counter": 500
          },
          model: {
            value: (_vm.form.descripcion),
            callback: function($$v) {
              _vm.$set(_vm.form, "descripcion", $$v)
            },
            expression: "form.descripcion"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs6": ""
          }
        }, [_c('v-text-field', {
          attrs: {
            "label": "Duración del trámite en días",
            "maxlength": "10"
          },
          model: {
            value: (_vm.form.duracion),
            callback: function($$v) {
              _vm.$set(_vm.form, "duracion", $$v)
            },
            expression: "form.duracion"
          }
        })], 1), _vm._v(" "), _c('v-flex', {
          attrs: {
            "xs6": ""
          }
        }, [_c('h5', [_vm._v("Información de pago")]), _vm._v(" "), _c('ul', {
          staticClass: "no-style"
        }, [_vm._l((_vm.form.monto), function(item, index) {
          return [_c('li', [_c('strong', [_vm._v("Nro. de Cuenta:")]), _vm._v(" " + _vm._s(item.cuenta) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Monto:")]), _vm._v(" Bs. " + _vm._s(item.monto) + "\n                        ")])]
        })], 2)])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('small', {
          staticClass: "error--text text-required"
        }, [_vm._v("* Los campos son obligatorios")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
          nativeOn: {
            "click": function($event) {
              return _vm.$store.commit('closeModal');
            }
          }
        }, [_c('v-icon', [_vm._v("cancel")]), _vm._v(" " + _vm._s(_vm.$t('common.cancel')))], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "primary",
            "type": "submit"
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("check")]), _vm._v(" " + _vm._s(_vm.$t('common.save')))], 1)], 1)], 1)]
      }
    }, {
      key: "items",
      fn: function(items) {
        return [_c('td', {
          staticClass: "nowrap"
        }, [(_vm.$store.state.permissions['documentos:update']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.editItem(items.item.id, 'documento', _vm.dataGraphql)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('span', [_vm._v("Editar registro")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.permissions['documentos:update']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.regenerar(items.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("vpn_key")])], 1), _vm._v(" "), _c('span', [_vm._v("Regenerar Token")])], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.permissions['documentos:delete']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [_c('v-btn', {
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.deleteItem(items.item.id, 'documento')
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "red"
          }
        }, [_vm._v("delete")])], 1), _vm._v(" "), _c('span', [_vm._v("Eliminar registro")])], 1) : _vm._e()], 1), _vm._v(" "), _c('td', [(_vm.$store.state.permissions['documentos:update']) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [(_vm.documento !== items.item.documento) ? _c('v-switch', {
          attrs: {
            "slot": "activator",
            "value": "ACTIVE",
            "color": "success"
          },
          on: {
            "change": function($event) {
              return _vm.changeActive(items.item, items.item.id, 'documento', 'EditDocumento')
            }
          },
          slot: "activator",
          model: {
            value: (items.item.active),
            callback: function($$v) {
              _vm.$set(items.item, "active", $$v)
            },
            expression: "items.item.active"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Activar/desactivar registro")])], 1) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
          attrs: {
            "bottom": ""
          }
        }, [(_vm.documento === items.item.documento) ? _c('router-link', {
          attrs: {
            "slot": "activator",
            "to": "/account"
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("file")])], 1) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Este documento soy yo, clic aquí para ir a mi cuenta.")])], 1)], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.nombre))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.descripcion))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.codigo_portal))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(items.item.entidad_nombre))]), _vm._v(" "), _c('td', [(items.item.derivar == 'ENTIDAD') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "warning",
            "text-color": "white"
          }
        }, [_vm._v("\n            " + _vm._s(items.item.derivar) + "\n          ")]) : _vm._e(), _vm._v(" "), (items.item.derivar == 'CANCILLERIA') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "info",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.derivar) + "\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('td', {
          staticClass: "text-md-right"
        }, [_vm._v(_vm._s(items.item.precio))]), _vm._v(" "), _c('td', [(items.item.estado == 'ACTIVO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "success",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e(), _vm._v(" "), (items.item.estado == 'INACTIVO') ? _c('v-chip', {
          attrs: {
            "label": "",
            "color": "warning",
            "text-color": "white"
          }
        }, [_vm._v("\n              " + _vm._s(items.item.estado) + "\n            ")]) : _vm._e()], 1)]
      }
    }])
  }, [_c('template', {
    slot: "buttons"
  }, [(_vm.$store.state.permissions['documentos:create']) ? _c('v-tooltip', {
    attrs: {
      "bottom": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.openDocs()
      }
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(" Agregar\n            ")], 1), _vm._v(" "), _c('span', [_vm._v("Agregar documento")])], 1) : _vm._e()], 1)], 2)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "600"
    },
    model: {
      value: (_vm.$store.state.modal3),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "modal3", $$v)
      },
      expression: "$store.state.modal3"
    }
  }, [(_vm.mydocs) ? _c('add-docs', {
    attrs: {
      "mydocs": _vm.mydocs
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "600"
    },
    model: {
      value: (_vm.$store.state.modal4),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "modal4", $$v)
      },
      expression: "$store.state.modal4"
    }
  }, [(_vm.doc) ? _c('regenerar', {
    attrs: {
      "doc": _vm.doc
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "320"
    },
    model: {
      value: (_vm.$store.state.modal5),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "modal5", $$v)
      },
      expression: "$store.state.modal5"
    }
  }, [_c('login-ppte')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0974be2e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/eApostilla/documento/Documento.vue
// module id = 492
// module chunks = 2